import $http from './index.js';
export const GetScoreRule= (data)=>{
    return $http.post('api/Score/GetScoreRule',data);
}
export const SaveScoreRule= (data)=>{
    return $http.post('api/Score/SaveScoreRule',data);
}
export const GetSoreProjectList= (data)=>{
    return $http.post('api/Score/GetSoreProjectList',data);
}
export const SaveScore= (data)=>{
    return $http.post('api/Score/SaveScore',data);
}
export const GetProjectSoreCountList= (data)=>{
    return $http.post('api/Score/GetProjectSoreCountList',data);
}
export const GetScoreDetail= (data)=>{
    return $http.post('api/Score/GetScoreDetail',data);
}